import { ApiPath } from "enums";
import { Get } from "utils";

export const getBillingsByFleet = async ({ fleetId, ...query }) => {
  const res = await Get(`${ApiPath.Billing}/fleet/${fleetId}`, query);
  return res.data;
};
